











































import { rollCallStudentList } from "@/api/rollCall";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() rollcallId!: number;
  @Prop() classData!: any;
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 3;
  pageSizeArray: number[] = [3, 10, 20];
  total: number = 0;
  dialogVisible: boolean = false;
  showDialog() {
    this.dialogVisible = true;
    this.getData({
      page: 1,
      page_size: this.pageSize,
    });
  }
  getData(data: { page: number; page_size: number }) {
    rollCallStudentList({
      page: data.page,
      page_size: data.page_size,
      roll_call_id: this.rollcallId,
    }).then((res: any) => {
      this.dialogVisible = true;
      res.data.list.map((a: any) => {
        a.remark = a.remark == "" ? "无" : a.remark;
        switch (a.student_status) {
          case 1:
            a.student_status = "到课";
            break;
          case 2:
            a.student_status = "迟到";
            break;
          case 3:
            a.student_status = "请假";
            break;
          case 4:
            a.student_status = "未到";
            break;
        }
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.page = res.data.page;
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getData({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getData({
      page: 1,
      page_size: e,
    });
  }
}
